<template>
  <div class="city">
    <mt-field label="所在地区：" class="inputStyle" disabled>
      <span @click="getPopup">{{address||'请选择所在地区'}}</span>
    </mt-field>
    <mt-popup v-model="popupVisible" position="bottom" popup-transition="popup-fade" fixed>
      <div @click="getPopup" class="showPopup">完成</div>
      <mt-picker :slots="slots" @change="onValuesChange" :visibleItemCount="5" valueKey="areaName"></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
export default {
  props: ['address'],
  data() {
    return {
      slots: [
        {
          flex: 1,
          defaultIndex: 0,
          values: [],
          className: 'slot1',
          textAlign: 'center',
        },
        {
          pider: true,
          content: '-',
        },
        {
          flex: 1,
          values: [],
          className: 'slot3',
          textAlign: 'center',
        },
        {
          pider: true,
          content: '-',
        },
        {
          flex: 1,
          values: [],
          className: 'slot5',
          textAlign: 'center',
        },
      ],
      popupVisible: false,
      province: null,
      city: null,
      area: null,
    }
  },
  mounted() {
    const _this = this
    this.$nextTick(() => {
      // 获取省数据
      _this
        .$http({
          url: '/live/area/list/-1',
          method: 'get',
        })
        .then((data) => {
          _this.slots[0].values = data.data.data
          // _this.province = data.data.data[0].areaName
        })
    })
  },
  methods: {
    getPopup() {
      this.popupVisible = !this.popupVisible
    },
    getArea(areaId, num) {
      this.$http({
        url: '/live/area/list/' + areaId,
        method: 'get',
      }).then((data) => {
        _this.slots[num].values = data.data.data
      })
    },
    onValuesChange(picker, values) {
      console.log(values)
      //判断如果省的id变化了，就去请求市和区，否则只请求区
      if (values[0] !== undefined && values[0].areaName !== this.province) {
        this.province = values[0].areaName
        this.$http({
          url: '/live/area/list/' + values[0].areaId,
          method: 'get',
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.slots[2].values = data.data

            // this.$http({
            //   url: '/live/area/list/' + data.data[0].areaId,
            //   method: 'get',
            // }).then(({ data }) => {
            //   if (data && data.code === 0) {
            //     this.slots[4].values = data.data
            //     this.area = data.data[0].areaName
            //   }
            // })
          }
        })
      }
      if (values[2] !== undefined && values[2].areaName !== this.city) {
        this.city = values[2].areaName
        this.$http({
          url: '/live/area/list/' + values[2].areaId,
          method: 'get',
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.slots[4].values = data.data
            this.area = data.data[0].areaName
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.showPopup {
  text-align: right;
  margin-right: 1rem;
  padding: 1rem 0;
  font-size: 18px;
}
/deep/ .mint-popup-bottom {
  width: 100%;
}
.inputStyle /deep/ .mint-field-core {
  flex: 0;
  padding: 0;
  width: 0;
}
</style>
